import React, { useState } from 'react';
import { cn } from '@strivelabs/ui-core';

export interface ChartLegendContentProps {
  payload?: any[];
  className?: string;
  nameKey?: string;
  hideIcon?: boolean;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  onMouseEnter?: (dataKey: string) => void;
  onMouseLeave?: () => void;
}

export const ChartLegendContent: React.FC<ChartLegendContentProps> = ({
  payload,
  className,
  nameKey = 'value',
  hideIcon = false,
  verticalAlign = 'bottom',
  onMouseEnter,
  onMouseLeave,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  if (!payload || payload.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-center gap-4 text-sm max-h-24 overflow-y-auto px-2',
        verticalAlign === 'top' && 'mb-4',
        verticalAlign === 'bottom' && 'mt-4',
        className
      )}
    >
      {payload.map((entry, index) => {
        const color = entry.color || entry.fill || entry.stroke;
        const dataKey = entry.dataKey || entry[nameKey];
        const isHovered = hoveredIndex === index;
        
        return (
          <div
            key={`legend-${index}`}
            className={cn(
              'flex items-center gap-2 cursor-pointer transition-all duration-200',
              isHovered && 'scale-115'
            )}
            onMouseEnter={() => {
              setHoveredIndex(index);
              if (onMouseEnter) {
                onMouseEnter(dataKey);
              }
            }}
            onMouseLeave={() => {
              setHoveredIndex(null);
              if (onMouseLeave) {
                onMouseLeave();
              }
            }}
          >
            {!hideIcon && (
              <div
                className="h-3 w-3 rounded-sm transition-all duration-200"
                style={{
                  backgroundColor: color,
                  transform: isHovered ? 'scale(1.1)' : 'scale(1)',
                }}
              />
            )}
            <span
              className={cn(
                'text-muted-foreground transition-colors duration-200',
                isHovered && 'text-foreground font-medium'
              )}
            >
              {entry[nameKey] || entry.dataKey}
            </span>
          </div>
        );
      })}
    </div>
  );
};